import PillsButtons from './PillsButtons';
import useStyles from './styles';
import { IPillsMenu } from './types';

function WithBorderPillsButtons(props: IPillsMenu) {
  const styles = useStyles({ orientation: props.orientation });
  return (
    <div className={styles.withBorder}>
      <PillsButtons {...props} />
    </div>
  );
}
export default WithBorderPillsButtons;
